import { DataService } from "../service";
import { ApiService } from "../libs";

const basicUrl = `${ApiService.EngineerApi}/search`; // 地址
export class TodaySearchService {
  /** 前台搜索接口start **/
  // 产品列表
  static async prodSearch(data: any = {}) {
    data = obj2qs(data);
    const res = await DataService.get(`${basicUrl}/prodSearch?${data}`);
    return res;
  }

  static async getPayQr() {
    return await DataService.get(`${basicUrl}/getPayQr`);
  }

  static async getPayType() {
    return await DataService.get(`${basicUrl}/getPayType`);
  }

  static async createMemberOrder() {
    return await DataService.post(`${ApiService.EngineerApi}/order/createMemberOrder`);
  }

  static async createMemberOrderList() {
    return await DataService.post(`${ApiService.EngineerApi}/order/createMemberOrderList`);
  }

  static async getMemberOrder(outTradeNo: string) {
    return await DataService.get(`${ApiService.EngineerApi}/order/getMemberOrder?outTradeNo=${outTradeNo}`);
  }

  /*
    搜索关键词(联想词)
    limit 数量 ；existsRef 	是否引用 可能感兴趣内容传true
  */
  static async getSearchKeyword(keyword: string = "", limit: number = 10, existsRef: boolean = false) {
    let url = existsRef ? `${basicUrl}/recommendKeywords?keyword=${keyword}&limit=${limit}&existsRef=${true}` : `${basicUrl}/recommendKeywords?keyword=${keyword}&limit=${limit}`
    const res = await DataService.get(url);
    return res;
  }
  // 推荐词查询产品
  static async recommendProducts(keyword: string = "", limit: number = 10) {
    const res = await DataService.get(`${basicUrl}/recommendProducts?keyword=${keyword}&limit=${limit}`);
    return res;
  }
  // 搜索反馈
  static async feedBackPost(keyword: string, content: string) {
    const res = await DataService.post(`${basicUrl}/feedback`, { keyword, content });
    return res;
  }
  /** 前台搜索接口end **/

  // 搜索关键词列表
  static async getKeywordByCompId(data: any = {}) {
    data = obj2qs(data);
    const res = await DataService.get(`${basicUrl}/getKeywordByCompId?${data}`);
    return res;
  }
  // 搜索关键词信息
  static async searchKeywordInfo(keyword: string = "") {
    const res = await DataService.get(`${basicUrl}/getKeyword?keyword=${keyword}`);
    return res;
  }
  // 关键词绑定产品
  static async bindKeywordToProd(data: any = {}) {
    const res = await DataService.post(`${basicUrl}/bindKeywordToProd`, data);
    return res;
  }
  // 删除关键词
  static async deleteKeywordByCompId(data: any = {}) {
    data = obj2qs(data);
    const res = await DataService.get(`${basicUrl}/deleteKeywordByCompId?${data}`);
    return res;
  }

  /**
   * 企业搜索
   * @param keyword 
   * @param sort 
   * @param page 
   * @param pageSize 
   * @returns 
   */
  static async searchCompany(keyword: string, sort = '', page = 1, pageSize = 20) {
    return await DataService.get(`${basicUrl}/searchCompany?keyword=${keyword}&sort=${sort}&page=${page}&pageSize=${pageSize}`);
  }
}

const obj2qs = function (obj: any = {}) {
  if (!obj && !Object.keys(obj).length) {
    return "";
  } else {
    var arr = [];
    for (var key in obj) {
      arr.push(key + "=" + obj[key]);
    }
    return arr.join("&");
  }
};
